import React, { useState, useEffect, useContext } from "react"

import PlaceBetFooter from "./footersUI/placeBet/PlaceBetFooter"
import CancelFooter from "./footersUI/cancel/CancelFooter"
import CashoutFooter from "./footersUI/cashout/CashoutFooter"
import AutoCashoutFooter from "./footersUI/autoCashout/AutoCashoutFooter"
import AutoCancelFooter from "./footersUI/autoCancel/autoCancelFooter"
import EndingFooter from "./footersUI/ending/EndingFooter"
import WaitFooter from "./footersUI/waitFooter/waitFooter"
import ToggleStats from "./toggleStats/ToggleStats"
import { FooterStyled } from "./styled"
import Train from "../train/Train"
import Coefficient from "../coefficient/Coefficient"
import SetStake from "../../../pages/setStake/SetStake"
import Cashout from "../../../lib/assets/audio/cashout.mp3"
import useSound from "use-sound"
import Auto from "../../../pages/auto/Auto"
import CashoutAtText from "./footersUI/autoCashout/CashoutAtText"
import { Notifications, SFXS } from "@orbital/games-frontend-library"
import { autoCashoutHelper } from "./helpers"
import { footerStateHandler } from "./handlers"
import { MyContext } from "../../../context/createContext"

export default function Footer({
  handleAbove,
  round,
  users,
  handleNotification,
  isError,
  roundState,
  audio,
  balance,
  placedBet,
  handleBetOnExplosion,
  setbetSend,
  betError,
  notification,
}: any) {
  const { ctx, setctx } = useContext(MyContext)
  const {
    auth,
    train,
    config,
    autoConfigs,
    autoCurrent,
    funcs,
    stake,
    astroSocketMessages,
  } = ctx
  const { betsRemained, isAutoOn } = autoCurrent
  const { handleAuto, stopAuto, handleStake, handleClear } = funcs
  const [footerState, setfooterState] = useState("placeBet")

  useEffect(() => {
    setctx((ctx: any) => {
      return { ...ctx, footerState }
    })
  }, [footerState, setctx])

  const [hasJustPlaced, sethasJustPlaced] = useState(false)
  const [isMybetInList, setisMybetInList] = useState(false)
  const [isCashouted, setisCashouted] = useState(false)
  const [isBetPlacedFromBrowser, setisBetPlacedFromBrowser] = useState(false)

  const [disableCancel, setdisableCancel] = useState(false)

  const [cashoutStake, setcashoutStake] = useState<any>(round.value * stake)
  const [usersInFooter, setusersInFooter] = useState<any>(users)

  useEffect(() => {
    setusersInFooter(users)
  }, [users])

  useEffect(() => {
    setcashoutStake((+(round.value * stake)).toFixed(config.prec))
  }, [round.value, stake, config.prec])

  // this useEffect is needed when bet was done but refreshed
  useEffect(() => {
    if (isBetPlacedFromBrowser) {
      return
    }
    // CANCELED = 0;
    // ACTIVE = 1;
    // CASHOUT = 2;
    // PENDING = 3;
    switch (placedBet.state) {
      case 1:
        if (footerState === "placeBet") {
          setisMybetInList(true)
          setusersInFooter((users: any) =>
            users.map((u: any) =>
              u.id === auth.player_id
                ? { ...u, bet: placedBet.bet, currency: placedBet.currency }
                : u
            )
          )
          handleStake((+placedBet.bet).toFixed(config.prec))
        }
        break
      case 2:
        if (footerState === "cashout") {
          setisMybetInList(false)
        }
        break
      case 3:
        if (footerState === "placeBet") {
          sethasJustPlaced(true)
          handleStake((+placedBet.bet).toFixed(config.prec))
        }
        break
      default:
        break
    }
  }, [
    placedBet,
    footerState,
    handleStake,
    isBetPlacedFromBrowser,
    // setisMybetInList,
    // usersInFooter,
    auth.player_id,
    config.prec,
  ])

  useEffect(() => {
    autoCashoutHelper(
      round,
      isMybetInList,
      isAutoOn,
      isCashouted,
      autoConfigs.cashoutAt,
      stake,
      betsRemained,
      setisMybetInList,
      stopAuto,
      setisCashouted,
      sethasJustPlaced
    )
  }, [
    round,
    isMybetInList,
    astroSocketMessages,
    isAutoOn,
    isCashouted,
    autoConfigs.cashoutAt,
    stake,
    betsRemained,
    setisMybetInList,
    stopAuto,
  ])

  const [showStat, setshowStat] = useState(false)
  const handleToggleStats = () => {
    setshowStat((s) => !s)
    SFXS.goForwardSFX.play()
  }

  useEffect(() => {
    if (round.state === 1) {
      let found = usersInFooter.some(
        (u: any) => u.id === auth.player_id && !!u.bet
      )
      setisMybetInList(found)
    }
  }, [usersInFooter, setisMybetInList, auth.player_id, round.state, isAutoOn])

  useEffect(() => {
    if (round.state === 1 && !isAutoOn) {
      if (hasJustPlaced) {
        setfooterState("cancelBet")
        astroSocketMessages.placeBet(
          stake,
          autoConfigs.cashoutAt,
          false,
          setbetSend
        )
      }
    }
  }, [
    round.state,
    hasJustPlaced,
    autoConfigs.numOfBets,
    autoConfigs.cashoutAt,
    astroSocketMessages,
    stake,
    isAutoOn,
    setbetSend,
  ])

  useEffect(() => {
    if (round.state === 1 && footerState === "ending") {
      if (isAutoOn) {
        setfooterState("waitForNext")
      } else {
        setfooterState("placeBet")
      }
    }
  }, [footerState, round.state, isAutoOn])

  useEffect(() => {
    if (betError === 108 && !isAutoOn) {
      // handleNotification(Notifications.notEnoughBalance)
      setfooterState("placeBet")
    }
    if (betError === 112) {
      handleNotification(Notifications.stageTimeout)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [betError, isAutoOn])

  useEffect(() => {
    if (
      notification === Notifications.invalidBet &&
      !isAutoOn &&
      hasJustPlaced
    ) {
      setfooterState("placeBet")
      sethasJustPlaced(false)
      // setisBetPlacedFromBrowser(false)
    }
  }, [notification, isAutoOn, hasJustPlaced])

  useEffect(() => {
    footerStateHandler(
      round.state,
      hasJustPlaced,
      isMybetInList,
      isCashouted,
      auth.player_id,
      isAutoOn,
      usersInFooter,
      setdisableCancel,
      setisCashouted,
      sethasJustPlaced,
      setfooterState,
      setisBetPlacedFromBrowser,
      placedBet,
      betError
    )
  }, [
    round.state,
    hasJustPlaced,
    isMybetInList,
    isCashouted,
    auth.player_id,
    stake,
    isAutoOn,
    usersInFooter,
    setisBetPlacedFromBrowser,
    placedBet,
    betError,
  ])

  const [cashoutSFX] = useSound(Cashout, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  useEffect(() => {
    isError && hasJustPlaced && sethasJustPlaced(false)
  }, [isError, hasJustPlaced])

  useEffect(() => {
    if (betError !== 0) {
      stopAuto()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoOn, betError])

  const placeBet = (e: string) => {
    if (balance < Number(e)) {
      handleNotification(Notifications.notEnoughBalance)
    } else {
      setisBetPlacedFromBrowser(true)
      sethasJustPlaced(true)
      setisCashouted(false)
    }
  }

  const cancelBet = () => {
    setisBetPlacedFromBrowser(true)
    sethasJustPlaced(false)
    setisMybetInList(false)
    if (isAutoOn) {
      stopAuto()
    }
  }

  const handleCashout = () => {
    setisBetPlacedFromBrowser(true)
    audio.sound && cashoutSFX()
    sethasJustPlaced(false)
    setisCashouted(true)
    setisMybetInList(false)
    astroSocketMessages.cashout()
  }

  const startAuto = (e: any) => {
    let cashout =
      e.betAmount <= 1 && e.cashoutAt < "1.015" ? "1.015" : e.cashoutAt
    if (e.betAmount > balance) {
      return handleNotification(Notifications.notEnoughBalance)
    }
    sethasJustPlaced(true)
    if (round.state === 1) {
      astroSocketMessages.placeBet(e.betAmount, cashout, true, setbetSend)
      if (e.numOfBets > 0) {
        handleAuto({ ...e, numOfBets: e.numOfBets - 1 })
      } else {
        handleAuto(e)
      }
    } else {
      handleAuto(e)
    }
  }
  const funcCashout = () => {
    stopAuto()
    setisCashouted(true)
    sethasJustPlaced(false)
    setisMybetInList(false)
    astroSocketMessages.cashout()
  }
  const funcStop = (e: any) => {
    stopAuto()
    setisCashouted(true)
    sethasJustPlaced(false)
    setisMybetInList(false)
    // setisBetPlacedFromBrowser(true)
  }

  const [modal, setModal] = useState<"setStake" | "auto" | false>(false)
  const [modalAnim, setModalAnim] = useState<"setStake" | "auto" | false>(false)
  const handleModal = (mod: "setStake" | "auto") => {
    if (modal) {
      setModalAnim(mod)
      setTimeout(() => {
        setModal(false)
        setModalAnim(false)
      }, 100)
    } else {
      setModal(mod)
    }
  }
  return (
    <FooterStyled className="footerStyled">
      {(roundState === "PLAY" || roundState === "END") && (
        <Coefficient coef={round.value} isLose={roundState === "END"} />
      )}
      {!modal && <Train round={round} history={train} />}
      {(footerState === "cashoutAuto" || footerState === "cancelAuto") && (
        <CashoutAtText
          cashoutAt={autoConfigs.cashoutAt}
          currency={auth.balance.currency}
        />
      )}
      {modal === "setStake" ? (
        <SetStake
          handleModal={handleModal}
          modalAnim={modalAnim === "setStake"}
          gameInfo={{
            minBet: config.minbet,
            maxBet: config.maxbet,
            precision: config.prec,
            currency: auth.balance.currency,
          }}
          handleStake={handleStake}
          handleNotification={handleNotification}
          audio={audio}
          currentStake={stake}
          balance={balance}
        />
      ) : modal === "auto" ? (
        <Auto
          handleModal={handleModal}
          modalAnim={modalAnim === "auto"}
          handleAuto={startAuto}
          handleNotification={handleNotification}
          round={round}
          handleBetOnExplosion={handleBetOnExplosion}
          // gameInfo={gameInfo}
          // stakesForSocket={stakesForSocket}
          // placeBet={placeBet}
        />
      ) : (
        <>
          <ToggleStats
            footerState={footerState}
            users={usersInFooter}
            handleToggleStats={handleToggleStats}
            showStat={showStat}
          />
          <PlaceBetFooter
            footerState={footerState}
            stake={stake}
            handleStake={handleStake}
            handleAbove={handleAbove}
            handleClear={handleClear}
            placeBet={placeBet}
            handleNotification={handleNotification}
            gameInfo={auth}
            handleModal={handleModal}
            audio={audio}
          />
          <CancelFooter
            footerState={footerState}
            stake={stake}
            cancelBet={cancelBet}
            disable={disableCancel}
            currency={auth.balance.currency}
            audio={audio}
          />
          <CashoutFooter
            footerState={footerState}
            cashoutStake={cashoutStake}
            handleCashout={handleCashout}
            currency={auth.balance.currency}
          />
          <AutoCashoutFooter
            footerState={footerState}
            cashoutStake={cashoutStake}
            currency={auth.balance.currency}
            betsRemained={betsRemained}
            funcCashout={funcCashout}
          />
          <AutoCancelFooter
            footerState={footerState}
            cashoutStake={cashoutStake}
            currency={auth.balance.currency}
            betsRemained={betsRemained}
            funcStop={funcStop}
            disable={disableCancel}
          />
          <WaitFooter footerState={footerState} />
          <EndingFooter footerState={footerState} />
        </>
      )}
    </FooterStyled>
  )
}
